module.exports = __webpack_public_path__ + "img/1440.4843f40a.svg";